"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerConverter = void 0;
var _reactResponsive = require("react-responsive");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _useContextSelector = require("use-context-selector");
var _ui = require("../../../../ui");
var _form = require("../../form");
var _fields = require("../../../../fields");
var _utils = require("../../../../../utils");
var _page = require("../page");
var _state = require("../../../../../state");
var _hooks = require("../../../../../hooks");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputCurrencyText = (0, _styledComponents.default)(_ui.MediumSpan)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var TickerConverter = function TickerConverter(_ref2) {
  var onAmountChange = _ref2.onAmountChange,
    onConvertedAmountChange = _ref2.onConvertedAmountChange,
    onConvertedTickerChange = _ref2.onConvertedTickerChange,
    ticker = _ref2.ticker,
    convertedTicker = _ref2.convertedTicker,
    control = _ref2.control,
    trigger = _ref2.trigger;
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.md
  });
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var convertedTickers = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.convertedTickers;
  });
  var convertedAmount = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.convertedTickerAmount;
  });
  var amount = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.amount;
  });
  var price = (0, _state.usePrice)({
    ticker: ticker,
    convertedTicker: convertedTicker
  });
  var _useSendTickerConvert = (0, _hooks.useSendTickerConverter)({
      price: price.value,
      amount: amount,
      convertedAmount: convertedAmount,
      ticker: ticker,
      convertedTicker: convertedTicker,
      onAmountChange: onAmountChange,
      onConvertedAmountChange: onConvertedAmountChange
    }),
    setFocusedInput = _useSendTickerConvert.setFocusedInput,
    focusedInput = _useSendTickerConvert.focusedInput;
  return /*#__PURE__*/_react.default.createElement(_form.TickerConverter, null, /*#__PURE__*/_react.default.createElement(_form.TickerConverterFormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    className: "d-flex justify-content-between"
  }, t('amount')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/_react.default.createElement(InputCurrencyText, null, ticker)), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: control,
    debounce: 500,
    inputProps: {
      name: 'amount',
      onFocus: function onFocus() {
        return setFocusedInput('amount');
      },
      onBlur: function onBlur() {
        return setFocusedInput(undefined);
      },
      onChange: function onChange() {
        if (focusedInput === 'amount') trigger('amount');
      },
      ticker: ticker
    }
  }))), !isTablet && /*#__PURE__*/_react.default.createElement(_form.TickerConverterEqualIcon, null), /*#__PURE__*/_react.default.createElement(_form.TickerConverterFormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('equivalent')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_form.TickerSelectInputAddon, {
    value: convertedTicker,
    options: convertedTickers,
    onChange: onConvertedTickerChange
  }), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: control,
    debounce: 500,
    inputProps: {
      name: 'convertedAmount',
      onFocus: function onFocus() {
        return setFocusedInput('convertedAmount');
      },
      ticker: convertedTicker
    }
  })), price.value && /*#__PURE__*/_react.default.createElement(_form.Rate, {
    ticker: ticker,
    convertedTicker: convertedTicker,
    price: price.value
  })));
};
exports.TickerConverter = TickerConverter;